import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React from "react";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import {
  useDeletePartMutation,
  useGetPartsMutation,
} from "../../redux/reducer/features/Part/partSlice";
import { AppFilter } from "../../models/app/AppModels";
import ServerAppGrid from "../../compenents/app/ServerAppGrid";
import { Part } from "../../models/features/Part/Parts";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { AppGridId } from "../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../services/utilities/utility";

export interface HomeProps {}

export const PartsGrid: React.FunctionComponent<HomeProps> = () => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Catalogue_Parts
    )
  );
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });

  const [partsData, partsDataResult] = useGetPartsMutation();
  const [parts, setParts] = React.useState<any[]>([]);
  const [selectedRow, setSelectedRow] = React.useState<Part>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [partsCount, setPartsCount] = React.useState<number>(0);
  const [deleteMutation, deleteMutationResult] = useDeletePartMutation();
  const [selectedRows, setSelectedRows] = React.useState<any>([]);

  let navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    item: Part
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(item);
  };
  const handleClose = (params: any) => {
    setAnchorEl(null);
  };

  const onDeletePart = (item: Part) => {
    setDeleteConfirm(false);
    deleteMutation({ data: { id: item.id } });
  };

  const fetchData = () => {
    partsData({ paging: paging });
  };

  React.useEffect(() => {
    if (
      deleteMutationResult.isSuccess &&
      deleteMutationResult.data.status === 0
    ) {
      fetchData();
    }
  }, [deleteMutationResult]);

  React.useEffect(() => {
    if (partsDataResult.data) {
      setParts(partsDataResult.data.entityList);
      setPartsCount(partsDataResult.data.totalRecords);
    }
  }, [partsDataResult]);

  React.useEffect(() => {
    fetchData();
  }, [paging]);
  React.useEffect(() => {
    console.log("Parts", parts);
  }, [parts]);
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 250,
      editable: true,
      filterable: false,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.manufacturer.title,
    },
    { field: "partNumber", headerName: "Part Number", width: 250 },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
    },
    {
      field: "shortName",
      headerName: "Short Name",
      flex: 1,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,

      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              onClick={(e) => {
                navigate(`/PartDetail/${params.row?.id}`);
              }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
            |
            <IconButton
              id="basic-button"
              onClick={(n) => {
                navigate(`/EditPart/${params.row?.id}`);
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
            |
            <IconButton
              id="basic-button"
              onClick={(n) => {
                setSelectedRow(params.row);
                setDeleteConfirm(true);
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Card>
        <ServerAppGrid
          gridId={AppGridId.Catalogue_Parts}
          data={parts}
          columns={GetAppGridColumns(
            columns,
            gridSetting?.columnVisibilityModel
          )}
          isLoading={partsDataResult.isLoading}
          paging={paging}
          onSelect={(newSelection: any) => {
            setSelectedRows(newSelection);
          }}
          setPaging={setPaging}
          totalRecords={partsCount}
          height={"70vh"}
          hideCheckBoxes={true}
        />
      </Card>
      <Dialog
        open={deleteConfirm}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete this part?</DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              if (selectedRow) onDeletePart(selectedRow);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
